/* eslint-disable */
import {
    Card,
    CardContent,
    Grid,
    RACButton,
    RACDatePicker,
    RACModalCard,
    RACRadio,
    RACSelect,
    RACTextbox,
    RACTooltip,
    Typography,
} from '@rentacenter/racstrap';
import React, { useContext, useEffect, useState } from 'react';
import { CostBasedPricingStyles } from '../Styles/CostBasedPricing';
import { CostBasedPricingContext } from './CostBasedPricingContext';
import { filterHierarchy, mapDropDownData } from '../../../utils/utils';
import { ReactComponent as Info } from '../../../assets/images/info-button.svg';
import { ReactComponent as RightAngle } from '../../../assets/images/angleRight.svg';
import { addPricingQueueAPI } from '../../../api/user';
import moment, { Moment } from 'moment';
import { CostBasedPricingFormData, ErrorMessage } from '../../shared/interface/CostBasedPricingInterface';
import { ReactComponent as WarningIcon } from "../../../assets/images/no-records-found.svg";

export default function CostBasedPricingForm(props: any) {
    console.log(props, 'propssssssss')
    const classes = CostBasedPricingStyles();
    const { zoneOptions, loader, setLoader, dropDownData, setDisplayGrid, pageDisplay, costBasedPricingFormData, setCostBasedPricingFormData,
        setDisplayForm, errorMessage, setErrorMessage, setPricingQueueId, costBasedFormData,
        setHandlePopup, handlePopup, userInfo, deptFormOptions, subDeptFormOptions, setsubDeptFormOptions, bracketFormOptions, setbracketFormOptions
    } = useContext(CostBasedPricingContext);
    const [popup, setPopup] = useState<boolean>(false)
    const [isEditScreen, setIsEditScreen] = useState<boolean>(false);
    const [endDisable, setEndDisable] = useState<boolean>(false)
    const currentDate = moment(moment(new Date()).format("YYYY-MM-DD"), "YYYY-MM-DD");
    const startDate = costBasedPricingFormData.startDate && moment(costBasedPricingFormData.startDate, "YYYY-MM-DD");
    const endDate = costBasedPricingFormData.endDate && moment(costBasedPricingFormData.endDate, "YYYY-MM-DD");
    const comparisonDate = moment("2099-12-31", "YYYY-MM-DD");
    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
    const endDateDisable = endDate && endDate.isSame(comparisonDate, 'day')
    const isDeptLevel = ((costBasedPricingFormData?.department) && (!costBasedPricingFormData?.subdepartment) && (!costBasedPricingFormData?.bracket));
    const disableDept = ((isEditScreen) && (isDeptLevel) && endDateDisable)
    const endDateMin = ((!isEditScreen) || (isDeptLevel && isEditScreen)) ? moment().format('YYYY-MM-DD') : moment().subtract(1, 'days').format('YYYY-MM-DD');

    useEffect(() => {
        setsubDeptFormOptions(mapDropDownData(dropDownData?.subdepartment, "descEn", 'subdepartmentNumber'));
        setbracketFormOptions(mapDropDownData(dropDownData?.bracket, "descEn", 'bracketNumber'));
        if (props?.formData != undefined) {
            setIsEditScreen(true);
            setCostBasedPricingFormData(props.formData)
        }
    }, [])

    const checkAllKeysHaveValue = (data: CostBasedPricingFormData, errorMessage: ErrorMessage): boolean => {
        const keysToSkip = ['subdepartment', 'bracket'];
        const keysCheck = Object.keys(data).every((key: string) => {
            if (keysToSkip.includes(key)) {
                return true;
            }
            return data[key] !== '';
        });
        const errorCheck = Object.values(errorMessage).every(value => value === '');
        console.log(keysCheck, errorCheck, errorMessage, 'errorCheckerrorCheckerrorCheckerrorCheck');
        return keysCheck && errorCheck;
    };

    function bindHierarchyDropDown(data: any[], filterKey: string, value: string | number, type: string) {
        const filteredData = filterHierarchy(data, filterKey, value);
        const dropDownData = mapDropDownData(filteredData, "descEn", type);
        if (type == 'subdepartmentNumber') {
            setsubDeptFormOptions(dropDownData)
        } else if (type == 'bracketNumber') {
            setbracketFormOptions(dropDownData)
        }
    }

    function onChangeField(key: string, value: any) {
        setCostBasedPricingFormData({ ...costBasedPricingFormData, [key]: value })
    }

    function notAcceptZeroAndNotExceedOne(e: any) {
        if (String(e.target.value?.[0]) == '0' && e.target.value?.[1]) {
            if (String(e.target.value?.[1]) != '.') {
                e.target.value = ''
            }
        } else if (String(e.target.value?.[0]) == '1' && e.target.value?.[1]) {
            e.target.value = e.target.value?.[0]
        } else if (String(e.target.value?.[0]) != '0' &&
            String(e.target.value?.[0]) != '1') {
            e.target.value = ''
        }
    }

    function allowTwoDigitsAfterDot(e: any) {
        const value = String(e.target.value);
        const split = value?.includes('.') ? value?.split('.') : [];
        if (value?.[0] == '.') {
            e.target.value = '';
        } else if (value?.[0] == '0' && value?.[1] == '0') {
            e.target.value = value?.[0];
        } else if ((value?.[3]) && ((value?.[1] != '.') && (value?.[2] != '.') && (value?.[3] != '.'))) {
            e.target.value = e.target.value?.[0] + e.target.value?.[1] + e.target.value?.[2];
        } else if (value.includes('.')) {
            const split = value?.split('.')
            if (split[1]?.length > 2) {
                e.target.value = split[0] + '.' + split[1]?.slice(0, 2)
            }
        }
    }

    function acceptOnlyFiveDigits(e: any) {
        const value = String(e.target.value);
        if (value?.[0] == '.') {
            e.target.value = ''
        } else if (value?.[0] == '0' && value?.[1] == '0') {
            e.target.value = value?.[0]
        } else if (!value?.includes('.') && (value?.[5]) && (value?.[5] != '.')) {
            e.target.value = value.slice(0, 5);
        } else if (value.includes('.')) {
            const split = value?.split('.')
            if (split[1]?.length > 2) {
                e.target.value = split[0] + '.' + split[1]?.slice(0, 2)
            }
        }
    }

    function minRatePctValidation(e: any) {
        const minRatePct = costBasedPricingFormData.minRatePct || e.target.value;
        if ((minRatePct) && (Math.ceil(Number(minRatePct)) == 0)) {
            setErrorMessage({ ...errorMessage, minRatePct: 'Min Rate % cannot be 0' })
        }
        else if ((minRatePct && costBasedPricingFormData.maxRatePct) && (Number(minRatePct) > Number(costBasedPricingFormData.maxRatePct))) {
            setErrorMessage({ ...errorMessage, minRatePct: 'Min Rate % cannot be greater than Max Rate %' })
        } else if ((errorMessage.maxRatePct != 'Max Rate % cannot be 0') && (errorMessage.minRatePct != 'Min Rate % cannot be 0')) {
            setErrorMessage({ ...errorMessage, minRatePct: '', maxRatePct: '' })
        } else {
            setErrorMessage({ ...errorMessage, minRatePct: '' })
        }
    }

    function maxRatePctValidation(e: any) {
        const maxRatePct = costBasedPricingFormData.maxRatePct || e.target.value;
        if ((maxRatePct) && (Math.ceil(Number(maxRatePct)) == 0)) {
            setErrorMessage({ ...errorMessage, maxRatePct: 'Max Rate % cannot be 0' })
        }
        else if ((maxRatePct && costBasedPricingFormData.minRatePct) && (Number(maxRatePct) < Number(costBasedPricingFormData.minRatePct))) {
            setErrorMessage({ ...errorMessage, maxRatePct: 'Max Rate % cannot be lesser than Min Rate %' })
        } else if ((errorMessage.maxRatePct != 'Max Rate % cannot be 0') && (errorMessage.minRatePct != 'Min Rate % cannot be 0')) {
            setErrorMessage({ ...errorMessage, minRatePct: '', maxRatePct: '' })
        } else {
            setErrorMessage({ ...errorMessage, maxRatePct: '' })
        }
    }

    function minRateNewValidation(e: any) {
        const minRateNew = costBasedPricingFormData.minRateNew || e.target.value;
        if (minRateNew && Number(minRateNew) < 0.99) {
            setErrorMessage({ ...errorMessage, minRateNew: 'The entered value cannot be less than 0.99' })
        }
        else if ((minRateNew && costBasedPricingFormData.maxRateNew) &&
            (Number(minRateNew) > Number(costBasedPricingFormData.maxRateNew))) {
            setErrorMessage({ ...errorMessage, minRateNew: 'Min Rate New cannot be greater than Max Rate New' })
        } else {
            setErrorMessage({ ...errorMessage, minRateNew: '', maxRateNew: '' })
        }
    }

    function maxRateNewValidation(e: any) {
        const maxRateNew = costBasedPricingFormData.maxRateNew || e.target.value;
        if (maxRateNew && Number(maxRateNew) < 0.99) {
            setErrorMessage({ ...errorMessage, maxRateNew: 'The entered value cannot be less than 0.99' })
        }
        else if ((maxRateNew && costBasedPricingFormData.minRateNew) && (Number(maxRateNew) < Number(costBasedPricingFormData.minRateNew))) {
            setErrorMessage({ ...errorMessage, maxRateNew: 'Max Rate New cannot be lesser than Min Rate New' })
        } else {
            setErrorMessage({ ...errorMessage, minRateNew: '', maxRateNew: '' })
        }
    }

    function minRateUsedValidation(e: any) {
        const minRateUsed = costBasedPricingFormData.minRateUsed || e.target.value;
        if (minRateUsed && Number(minRateUsed) < 0.99) {
            setErrorMessage({ ...errorMessage, minRateUsed: 'The entered value cannot be less than 0.99' })
        } else if ((minRateUsed && costBasedPricingFormData.maxRateUsed) && (Number(minRateUsed) > Number(costBasedPricingFormData.maxRateUsed))) {
            setErrorMessage({ ...errorMessage, minRateUsed: 'Min Rate Used cannot be greater than Max Rate Used' })
        } else {
            setErrorMessage({ ...errorMessage, minRateUsed: '', maxRateUsed: '' })
        }
    }

    function maxRateUsedValidation(e: any) {
        const maxRateUsed = costBasedPricingFormData.maxRateUsed || e.target.value;
        if (maxRateUsed && Number(maxRateUsed) < 0.99) {
            setErrorMessage({ ...errorMessage, maxRateUsed: 'The entered value cannot be less than 0.99' })
        } else if ((maxRateUsed && costBasedPricingFormData.minRateUsed) && (Number(maxRateUsed) < Number(costBasedPricingFormData.minRateUsed))) {
            setErrorMessage({ ...errorMessage, maxRateUsed: 'Max Rate Used cannot be lesser than Min Rate Used' })
        } else {
            setErrorMessage({ ...errorMessage, minRateUsed: '', maxRateUsed: '' })
        }
    }

    async function submitFunction(endConfigure?: boolean) {
        setLoader({ ...loader, mainPage: true });
        const pricingRuleDetailsReq = formAddPricingQueueRequest(costBasedPricingFormData, endConfigure)
        let req = {
            schedule: costBasedPricingFormData.schedule,
            status: "WAITING",
            submittedBy: userInfo.userName,
            type: "COSTRULES",
            queueData: {
                pricingRuleDetails: pricingRuleDetailsReq
            }
        }
        const response = await addPricingQueueAPI(req);
        console.log(response, 'addpricresponse')
        setLoader({ ...loader, mainPage: false });
        setDisplayForm(false)
        if (pageDisplay != 0) {
            setDisplayGrid(true)
        } else {
            setDisplayGrid(false)
        }
        if (response.status == 200) {
            setCostBasedPricingFormData(costBasedFormData)
            setPricingQueueId(response.data.pricingQueueId)
            setHandlePopup({ ...handlePopup, isOpen: true, Content: 'Request has been submitted.', type: 'success' })
        }
        else if (response.status == 400) {
            const content = response.data?.errors[0]?.error?.trim()?.length > 0 ? response.data?.errors[0]?.error?.trim() : 'Something went wrong';
            setHandlePopup({ isOpen: true, Content: content, index: 0, type: 'error' });
        } else {
            const content = response.data?.errors[0]?.error?.trim()?.length > 0 ? response.data?.errors[0]?.error?.trim() : 'Something went wrong'
            setHandlePopup({ isOpen: true, Content: content, index: 0, type: 'error' });
        }
    }

    function breadCrums() {
        return (
            <>
                <Typography variant='body1' className={`${classes.greyColor} ${classes.fs12} ${classes.cursorStyle}`}>
                    <span onClick={() => {
                        setDisplayForm(false)
                        if (pageDisplay != 0) {
                            setDisplayGrid(true)
                        } else {
                            setDisplayGrid(false)
                        }
                    }}> Cost Based Pricing Details </span>
                    <span className={`${classes.ml10}`}><RightAngle className={`${classes.h10}`} style={{ color: 'grey' }} /></span>
                    <span className={`${classes.ml10} ${classes.cursorStyle} ${classes.textBlue}`}
                    > {isEditScreen ? 'Update Cost Based Pricing' : ' New Cost Based Pricing'} </span>
                </Typography>
            </>
        )
    }

    const popUp = () => {
        return (
            <>
                <Grid>
                    <Grid style={{ justifyContent: "center", display: "flex" }}>
                        <WarningIcon width={"8%"} height={"9%"} />
                    </Grid>
                    <Grid style={{ padding: '1%' }}>
                        <Typography variant="h5" style={{ textAlign: "center", marginBottom: '3%', marginTop: '2%' }} >
                            Are you sure want to end this configuration?
                        </Typography>
                        <span style={{ textAlign: "center", marginLeft: '20px', fontFamily: 'OpenSans-semibold' }}><span style={{ fontFamily: 'OpenSans-bold' }}>Note: </span> The end date will be updated to yesterday's date</span>
                    </Grid>
                    <Grid style={{ display: "flex", justifyContent: "center", margin: "5%" }}>
                        <RACButton
                            style={{ marginRight: "10%" }}
                            variant="outlined"
                            onClick={() => setPopup(false)}
                        >
                            No
                        </RACButton>
                        <RACButton
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setPopup(false)
                                submitFunction(true);
                            }}
                        >
                            Yes
                        </RACButton>
                    </Grid>
                </Grid>
            </>
        );
    };

    function footerCard() {
        return (
            <>
                <Card style={{ position: "fixed", bottom: "0px", width: "100%", zIndex: "1", left: "0" }}>
                    <CardContent style={{ padding: '5px 10px 10px 0px' }}>
                        <Grid md={12} lg={12} sm={12} xs={12} spacing={3}>
                            <RACButton
                                variant="contained"
                                color="primary"
                                size="small"
                                style={{ float: "right", margin: '10px' }}
                                disabled={checkAllKeysHaveValue(costBasedPricingFormData, errorMessage) ? false : true}
                                onClick={() => {
                                    if (startDate?.isBefore(currentDate) && !(endDate.isSame(yesterday))) {
                                        setErrorMessage({ ...errorMessage, startDate: 'Start Date should not be a past date' })
                                    }
                                    else if (startDate?.isAfter(endDate) || endDate?.isSame(yesterday)) {
                                        setPopup(true)
                                    } else {
                                        submitFunction()
                                    }
                                }}
                            >
                                Submit
                            </RACButton>
                            <RACButton
                                color="primary"
                                variant="outlined"
                                size="large"
                                style={{ float: "right", margin: '10px' }}
                                onClick={() => {
                                    setDisplayForm(false)
                                    if (pageDisplay != 0) {
                                        setDisplayGrid(true)
                                    } else {
                                        setDisplayGrid(false)
                                    }
                                }}
                            >
                                Cancel
                            </RACButton>
                        </Grid>
                    </CardContent>
                </Card>
            </>
        )
    }

    const handleInputChange = (e: any, regex: RegExp, replace: RegExp) => {
        !regex.test(e.target.value)
            ? (e.target.value = e.target.value.replace(replace, ''))
            : null;
    };

    function formAddPricingQueueRequest(data: CostBasedPricingFormData, endConfigure?: boolean) {
        const request = {
            zoneNumber: [data.zone],
            departmentNumber: data.department,
            subdepartmentNumber: data.subdepartment || null,
            bracketNumber: data.bracket || null,
            startDate: data.startDate,
            endDate: endConfigure ? yesterday : data.endDate,
            publishPriceFlag: (data.publishPriceForExisitingRMS)?.toUpperCase(),
            costBasedRules: {
                minRatePct: data.minRatePct,
                maxRatePct: data.maxRatePct,
                minRateNew: data.minRateNew,
                maxRateNew: data.maxRateNew,
                minRateUsed: data.minRateUsed,
                maxRateUsed: data.maxRateUsed,
                turn: data.turns,
                maxTerm: data.termMax,
                initAmount: data.initialAmount,
                growth: data.growth,
                lineShiftLR: data.lineShiftLr,
                lineShiftUD: data.lineShiftUd,
                usedRateAdj: data.usedRateAdjustment,
                publishOnCostChangeFlag: (data.publishPriceWhenCostChanges)?.toUpperCase()
            }
        }
        return request;
    }

    function isValidDate(date: Moment) {
        return date?.isValid();
    }

    function dateValidation(startDate: any, endDate: any) {
        const newErrorMessage = { ...errorMessage, startDate: '', endDate: '' };
        if (startDate._i === undefined || !isValidDate(startDate)) {
            newErrorMessage.startDate = 'Start Date is not a valid date';
        }
        if (endDate._i === undefined || !isValidDate(endDate)) {
            newErrorMessage.endDate = 'End Date is not a valid date';
        }
        if (!isEditScreen && startDate && endDate && currentDate) {
            if (startDate?.isBefore(currentDate)) {
                newErrorMessage.startDate = 'Start Date should not be a past date';
            } else if (startDate && endDate && startDate?.isAfter(endDate)) {
                newErrorMessage.startDate = 'Start Date cannot be greater than End Date';
            }

            if (endDate?.isBefore(currentDate)) {
                newErrorMessage.endDate = 'End Date should not be a past date';
            } else if (endDate && startDate && endDate?.isBefore(startDate)) {
                newErrorMessage.endDate = 'End Date cannot be earlier than Start Date';
            }
        } else if (isEditScreen && startDate && endDate && currentDate) {
            if (disableDept && startDate?.isBefore(currentDate)) {
                newErrorMessage.startDate = 'Start Date should not be a past date';
            } else if (endDate?.isSameOrAfter(currentDate) && startDate?.isBefore(currentDate)) {
                newErrorMessage.startDate = 'Start Date should not be a past date';
            } else if (endDate.isBefore(currentDate) && !endDate.isSame(yesterday)) {
                newErrorMessage.endDate = `End Date should not be a past date other than yesterday's date`;
            }
        }
        setErrorMessage(newErrorMessage);
    }

    console.log(costBasedPricingFormData, 'costBasedPricingFormDatacostBasedPricingFormData')
    return (
        <>
            <Grid container md={12} className={`${classes.pagePadding1}`}>
                <Grid container md={12} style={{ marginBottom: '15px' }}>
                    {breadCrums()}
                </Grid>
                <Grid container style={{ width: '100%' }}>
                    <Grid container style={{ width: '49%', marginRight: '1%' }}>
                        <Grid item md={12} style={{ marginBottom: '10px' }}>
                            <Typography variant='h4'>{isEditScreen ? 'Update Cost Based Pricing' : ' New Cost Based Pricing'}</Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Card className={classes.card} style={{ height: '70vh', overflowY: 'auto' }}>
                                <CardContent style={{ paddingRight: '0px' }}>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={4}>
                                            <RACSelect
                                                inputLabel="Zone"
                                                required={true}
                                                defaultValue={costBasedPricingFormData?.zone}
                                                options={zoneOptions}
                                                isDisabled={true}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACSelect
                                                inputLabel="Department"
                                                required={true}
                                                defaultValue={costBasedPricingFormData?.department}
                                                options={deptFormOptions}
                                                isDisabled={isEditScreen}
                                                loading={loader.dropdownLoader}
                                                onChange={(e) => {
                                                    bindHierarchyDropDown(dropDownData?.subdepartment, 'departmentNumber', e.target.value, 'subdepartmentNumber')
                                                    if ((!isEditScreen) && (e.target.value) && !(costBasedPricingFormData?.subdepartment && costBasedPricingFormData?.bracket)) {
                                                        setEndDisable(true);
                                                    } else if (!isEditScreen) {
                                                        setEndDisable(false);
                                                    }
                                                    setCostBasedPricingFormData({
                                                        ...costBasedPricingFormData, department: e.target.value,
                                                        subdepartment: '', bracket: '', endDate: '2099-12-31'
                                                    })
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACSelect
                                                inputLabel="Sub Department"
                                                defaultValue={costBasedPricingFormData?.subdepartment}
                                                options={subDeptFormOptions}
                                                isDisabled={(isEditScreen) || (costBasedPricingFormData?.department ? false : true)}
                                                onChange={(e) => {
                                                    setCostBasedPricingFormData({ ...costBasedPricingFormData, subdepartment: e.target.value, bracket: '', endDate: '' })
                                                    bindHierarchyDropDown(dropDownData?.bracket, 'subdepartmentNumber', e.target.value, 'bracketNumber')
                                                    if ((!isEditScreen) && (!e.target.value) && (costBasedPricingFormData?.department)) {
                                                        setEndDisable(true);
                                                        setCostBasedPricingFormData({ ...costBasedPricingFormData, subdepartment: e.target.value, bracket: '', endDate: '2099-12-31' })
                                                    } else if (!isEditScreen) {
                                                        setEndDisable(false);
                                                        setCostBasedPricingFormData({ ...costBasedPricingFormData, subdepartment: e.target.value, bracket: '' })
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={4}>
                                            <RACSelect
                                                inputLabel="Bracket"
                                                defaultValue={costBasedPricingFormData?.bracket}
                                                options={bracketFormOptions}
                                                isDisabled={(isEditScreen) || ((costBasedPricingFormData?.department &&
                                                    costBasedPricingFormData?.subdepartment) ? false : true)}
                                                onChange={(e) => {
                                                    onChangeField('bracket', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACDatePicker
                                                label="Start date"
                                                required={true}
                                                errorMessage={errorMessage.startDate}
                                                value={costBasedPricingFormData?.startDate}
                                                inputProps={{
                                                    min: ((!isEditScreen) || (isEditScreen && isDeptLevel)) ? moment().format('YYYY-MM-DD') : null,
                                                    max: '2099-12-31',
                                                }}
                                                onChange={(e) => {
                                                    const startDate = moment(e, "YYYY-MM-DD");
                                                    dateValidation(startDate, endDate)
                                                    onChangeField('startDate', e)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <RACDatePicker
                                                label="End date"
                                                required={true}
                                                errorMessage={errorMessage.endDate}
                                                value={costBasedPricingFormData?.endDate}
                                                disabled={endDisable || disableDept}
                                                onChange={(e) => {
                                                    const endDate = moment(e, "YYYY-MM-DD");
                                                    dateValidation(startDate, endDate)
                                                    onChangeField('endDate', e)
                                                }
                                                }
                                                inputProps={{
                                                    min: endDateMin,
                                                    max: '2099-12-31',
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '10px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title5}>Do you want to generate new price for existing RMS items?</span>
                                            <span style={{ color: 'red', marginLeft: '5px' }}> * </span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={costBasedPricingFormData?.publishPriceForExisitingRMS == 'Yes'}
                                                    label="Yes (Generate new price to existing and future RMS items)"
                                                    name="existingRMS"
                                                    onClick={() => onChangeField('publishPriceForExisitingRMS', 'Yes')}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={costBasedPricingFormData?.publishPriceForExisitingRMS == 'No'}
                                                    label="No (Generate new price only to future RMS items)"
                                                    name="existingRMS"
                                                    onClick={() => onChangeField('publishPriceForExisitingRMS', 'No')}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '10px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title5}>Do you want to generate new price when the purchase cost changes?</span>
                                            <span style={{ color: 'red', marginLeft: '5px' }}> * </span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={costBasedPricingFormData?.publishPriceWhenCostChanges == 'Yes'}
                                                    label="Yes"
                                                    name="purchaseCost"
                                                    onClick={() => onChangeField('publishPriceWhenCostChanges', 'Yes')}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={costBasedPricingFormData?.publishPriceWhenCostChanges == 'No'}
                                                    label="No"
                                                    name="purchaseCost"
                                                    onClick={() => onChangeField('publishPriceWhenCostChanges', 'No')}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} style={{ marginBottom: '10px' }}>
                                        <Grid item md={12}>
                                            <span className={classes.title5}>How do you want to update the Cost Based Pricing?</span>
                                            <span style={{ color: 'red', marginLeft: '5px' }}> * </span>
                                            <Grid style={{ margin: '1%' }}>
                                                <RACRadio
                                                    value={''}
                                                    checked={costBasedPricingFormData?.schedule == 'IMMEDIATE'}
                                                    label="Immediately"
                                                    name="schedule"
                                                    onClick={() => onChangeField('schedule', 'IMMEDIATE')}
                                                />
                                                <RACRadio
                                                    value={''}
                                                    checked={costBasedPricingFormData?.schedule == 'OVERNIGHT'}
                                                    label="Overnight"
                                                    name="schedule"
                                                    onClick={() => onChangeField('schedule', 'OVERNIGHT')}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Grid container style={{ width: '50%' }}>
                        <Grid item md={12} style={{ marginBottom: '10px' }}>
                            <Typography variant='h4'>Cost Based Foundation Rules</Typography>
                        </Grid>
                        <Grid item md={12}>
                            <Card className={classes.card} style={{ height: '70vh', overflowY: 'auto' }}>
                                <CardContent style={{ paddingRight: '0px' }}>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={3}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Min Rate %'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.minRatePct}
                                                placeHolder='Example: 0.035'
                                                required={true}
                                                errorMessage={errorMessage.minRatePct}
                                                Onblur={(e) => {
                                                    minRatePctValidation(e)
                                                }}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    notAcceptZeroAndNotExceedOne(e)
                                                    onChangeField('minRatePct', e.target.value);
                                                }}
                                                maxlength={8}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Max Rate %'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.maxRatePct}
                                                placeHolder='Example: 0.09'
                                                required={true}
                                                errorMessage={errorMessage.maxRatePct}
                                                Onblur={(e) => {
                                                    maxRatePctValidation(e)
                                                }}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    notAcceptZeroAndNotExceedOne(e)
                                                    onChangeField('maxRatePct', e.target.value);
                                                }}
                                                maxlength={8}
                                            />
                                        </Grid>
                                        <Grid item md={3} className={classes.currencyInputStyle}>
                                            <RACTextbox
                                                type='text'
                                                isCurrency={true}
                                                inputlabel='Min Rate (NEW)'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.minRateNew}
                                                required={true}
                                                Onblur={(e) => {
                                                    minRateNewValidation(e)
                                                }}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    allowTwoDigitsAfterDot(e)
                                                    onChangeField('minRateNew', e.target.value)
                                                }}
                                                maxlength={6}
                                            />
                                            <span className={classes.errorMessage}>{errorMessage.minRateNew}</span>
                                        </Grid>
                                        <Grid item md={3} className={classes.currencyInputStyle}>
                                            <RACTextbox
                                                type='text'
                                                isCurrency={true}
                                                inputlabel='Max Rate (NEW)'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.maxRateNew}
                                                required={true}
                                                Onblur={(e) => {
                                                    maxRateNewValidation(e)
                                                }}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    allowTwoDigitsAfterDot(e)
                                                    onChangeField('maxRateNew', e.target.value)
                                                }}
                                                maxlength={6}
                                            />
                                            <span className={classes.errorMessage}>{errorMessage.maxRateNew}</span>
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={3} className={classes.currencyInputStyle}>
                                            <RACTextbox
                                                type='text'
                                                isCurrency={true}
                                                inputlabel='Min Rate (USED)'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.minRateUsed}
                                                required={true}
                                                Onblur={(e) => {
                                                    minRateUsedValidation(e)
                                                }}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    allowTwoDigitsAfterDot(e)
                                                    onChangeField('minRateUsed', e.target.value)
                                                }}

                                                maxlength={6}
                                            />
                                            <span className={classes.errorMessage}>{errorMessage.minRateUsed}</span>
                                        </Grid>
                                        <Grid item md={3} className={classes.currencyInputStyle}>
                                            <RACTextbox
                                                type='text'
                                                isCurrency={true}
                                                inputlabel='Max Rate (USED)'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.maxRateUsed}
                                                required={true}
                                                Onblur={(e) => {
                                                    maxRateUsedValidation(e)
                                                }}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    allowTwoDigitsAfterDot(e)
                                                    onChangeField('maxRateUsed', e.target.value)
                                                }}
                                                maxlength={6}
                                            />
                                            <span className={classes.errorMessage}>{errorMessage.maxRateUsed}</span>
                                        </Grid>
                                        <Grid item md={3}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Turns'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.turns}
                                                placeHolder='Example: 3.5'
                                                required={true}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    const value = String(e.target.value);
                                                    if ((value?.[0] == '.') || (value?.[0] == '0')) {
                                                        e.target.value = ''
                                                    } else if (value?.[2] && value?.[1] != '.' && value?.[2] != '.') {
                                                        e.target.value = e.target.value?.[0] + e.target.value?.[1];
                                                    } else if (value?.[1] == '.' && value?.[8]) {
                                                        e.target.value = value.slice(0, value.length - 1)
                                                    }
                                                    onChangeField('turns', e.target.value)
                                                }}
                                                maxlength={9}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Term Max'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.termMax}
                                                errorMessage={errorMessage.termMax}
                                                placeHolder='Example: 104'
                                                required={true}
                                                maxlength={3}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]+$/, /[^0-9]/g);
                                                    if ((String(e.target.value?.[0]) == '.') || (String(e.target.value?.[0]) == '0')) {
                                                        e.target.value = ''
                                                    }
                                                    onChangeField('termMax', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid item md={3}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Initial Amount (A)'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.initialAmount}
                                                placeHolder='Example: 0.036'
                                                required={true}
                                                maxlength={8}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    notAcceptZeroAndNotExceedOne(e)
                                                    onChangeField('initialAmount', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Growth (r)'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.growth}
                                                placeHolder='Example: 0.0007'
                                                required={true}
                                                maxlength={8}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    notAcceptZeroAndNotExceedOne(e)
                                                    onChangeField('growth', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Line Shift LR (m)'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.lineShiftLr}
                                                placeHolder='Example: -150'
                                                required={true}
                                                maxlength={8}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^-?[0-9]*\.?[0-9]+$/, /[^0-9.-]|(?!^)-|(?<=\..*)\./g);
                                                    acceptOnlyFiveDigits(e);
                                                    onChangeField('lineShiftLr', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                        <Grid item md={3}>
                                            <RACTextbox
                                                type='text'
                                                inputlabel='Line Shift UD (k)'
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.lineShiftUd}
                                                placeHolder='Example: 0.025'
                                                required={true}
                                                maxlength={8}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    notAcceptZeroAndNotExceedOne(e)
                                                    onChangeField('lineShiftUd', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container md={12} spacing={2} style={{ marginBottom: '10px' }}>
                                        <Grid container md={12} style={{ fontFamily: 'OpenSans-semibold', margin: '5px 0px -5px 5px' }}>Used Rate Adjustment (y) <span style={{ color: 'red', marginLeft: '5px' }}> * </span>
                                            <RACTooltip
                                                placement={'right'}
                                                classes={{ tooltip: classes.tooltipcss1, arrow: classes.tooltipStyling1 }}
                                                title={
                                                    <span style={{ fontSize: '11px' }}>This value will be subtracted from the New Rate to calculate the Used Rate</span>
                                                }
                                            >
                                                <Info className={`${classes.width6}`} />
                                            </RACTooltip>
                                        </Grid>
                                        <Grid item md={3} className={classes.currencyInputStyle}>
                                            <RACTextbox
                                                type='text'
                                                isCurrency={true}
                                                inputLabelClassname={classes.title3}
                                                value={costBasedPricingFormData.usedRateAdjustment}
                                                maxlength={6}
                                                OnChange={(e) => {
                                                    handleInputChange(e, /^[0-9]*\.?[0-9]+$/, /[^0-9.]|(?<=\..*)\./g);
                                                    allowTwoDigitsAfterDot(e)
                                                    onChangeField('usedRateAdjustment', e.target.value)
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container md={12}>
                {footerCard()}
            </Grid>
            <RACModalCard
                isOpen={popup}
                maxWidth="xs"
                borderRadius={10}
                closeIcon={true}
                onClose={() => setPopup(false)}
            >
                {popUp()}
            </RACModalCard>
        </>
    )
}
